import { render, staticRenderFns } from "./AddFormula.vue?vue&type=template&id=61f917bf"
import script from "./AddFormula.vue?vue&type=script&lang=js"
export * from "./AddFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports